<template>
  <div class="addStaff">
    <div class="header">
      <div @click="onCancel">取消</div>
      <div>添加内部参会人</div>
      <div class="select">
        <van-button type="primary" size="mini" @click="() => selectAll(true)">全选</van-button>
        <van-button type="info" size="mini" style="margin-left: 1em" @click="() => selectAll(false)">反选</van-button>
      </div>
    </div>
    <div class="search">
      <van-search
        v-model="search"
        placeholder="请输入搜索关键词"
        class="van-field__control"
        @input="onSearch"
        @cancel="onCancelSearch"
      />
    </div>
    <div class="content">
      <div>
        <Bread :bread-list="breadcrumbList" @onBread="getTree" />
      </div>
      <TreeList :tree-list="treeList" pick-name="staff" pick-type="multiple" :picked-list.sync="pickedList" @getTree="getTree" @onChange="changePicked" />
    </div>
    <div class="footer">
      <div class="part">
        <div class="info" @click="seePickedStaff">
          已选择{{ pickedList.length }}人
          <svg-icon icon-class="arrow-t" style="font-size: 0.12rem; margin-left: 1em" />
        </div>
        <div>
          <van-button type="info" style="margin-left: 1em" @click="onConfirm">确定</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { staffMaps, searchStaff } from '@/api/user';
import Bread from '@/components/Breadcrumb';
import TreeList from '@/components/TreeList';
import { Search } from 'vant';

export default {
  name: 'AddStaff',
  components: {
    Bread,
    TreeList,
    [Search.name]: Search
  },
  data() {
    return {
      staffList: [],
      pickedList: [],
      treeList: [],
      breadcrumbList: [],
      search: '',
      parentId: ''
    };
  },
  computed: {
    staffIds() {
      this.pickedList = this.$store.state.staffIds;
      return this.$store.state.staffIds;
    }
  },
  watch: {
    search(val) {
      if (val.length === 0) {
        this.getTree(this.parentId);
      }
    },
    pickedList(val) {
      this.$store.dispatch('setStaffIds', { list: val });
    },
    staffIds() {}
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === 'roomInfo') {
        vm.pickedList = vm.$store.state.submitForm.inners;
      }
    });
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      staffMaps({}).then(res => {
        if (res.data) {
          this.staffList = JSON.parse(JSON.stringify(res.data));
          this.treeList = JSON.parse(JSON.stringify(res.data.nodes));
          const id = this.$store.state.staffParentId === 0 ? res.data.id : this.$store.state.staffParentId;
          this.getTree(id);
        }
      });
    },
    getTree(id) {
      if (id) {
        this.parentId = id;
        this.$store.dispatch('setStaffParentId', { id: id });
        const staffList = this.staffList;
        const that = this;
        const list = this.getParent([staffList], id).reverse();
        // eslint-disable-next-line no-inner-declarations
        function deepData(arr) {
          arr.forEach(item => {
            if (item.id === id) {
              that.treeList = item.nodes;
              list.push({ id: item.id, name: item.name });
            } else if (item.nodes) {
              deepData(item.nodes);
            }
          });
        }
        deepData([staffList]);
        this.breadcrumbList = list;
      }
    },
    getParent(data, val) {
      for (let i = 0; i < data.length; i++) {
        if (data[i] && data[i].id === val) {
          return [];
        }
        if (data[i] && data[i].nodes) {
          const d = this.getParent(data[i].nodes, val);
          if (d) {
            return d.concat({ id: data[i].id, name: data[i].name });
          }
        }
      }
    },
    getSon(list) {
      const ids = [];
      function deepData(arr) {
        arr.forEach(item => {
          if (item.type === 'staff') {
            ids.push(item.id);
          }
          if (item.nodes) {
            deepData(item.nodes);
          }
        });
      }
      deepData(list);
      return ids;
    },
    changePicked(e) {
      this.pickedList = [...new Set([...this.pickedList, ...e])];
    },
    selectAll(type) {
      const list = this.treeList;
      const staffList = [];
      let otherList = [];
      list.forEach(item => {
        if (item.type === 'staff') {
          staffList.push(item.id);
        } else {
          const sonList = this.getSon(item.nodes);
          otherList = [...new Set([...otherList, ...sonList])];
        }
      });
      if (type) {
        this.pickedList = [...new Set([...this.pickedList, ...otherList, ...staffList])];
      } else {
        const ids = [...new Set([...otherList, ...staffList])];
        this.pickedList = this.pickedList.filter(item => {
          return !ids.includes(item);
        });
      }
    },
    seePickedStaff() {
      this.$router.push({
        name: 'pickedStaff',
        query: {
          pickedList: JSON.stringify(this.pickedList),
          treeList: JSON.stringify(this.treeList),
          staffList: JSON.stringify(this.staffList)
        }});
    },
    onSearch() {
      if (this.search.length > 0) {
        searchStaff({ search: this.search }).then(res => {
          res.data.forEach(item => {
            item.type = 'staff';
          });
          this.treeList = JSON.parse(JSON.stringify(res.data));
        });
      }
    },
    onCancelSearch() {
      this.getTree(this.parentId);
    },
    onCancel() {
      this.$store.dispatch('setStaffIds', { list: [] });
      this.$router.push({
        name: 'roomInfo'
      });
    },
    onConfirm() {
      // pickedList
      this.$router.push({
        name: 'roomInfo'
      });
      this.$store.dispatch('setInners', { list: this.pickedList });
    }
  }
};
</script>

<style lang="less">
.addStaff {
  position: relative;
  .search {
    .van-field__control {
      text-align: left;
    }
  }

  .header {
    height: 0.44rem;
    font-size: 0.17rem;
    font-weight: 400;
    line-height: 0.24rem;
    color: #333333;
    background: #FFFFFF;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.135rem;
    .confirm {
      color: #3B86FF;
    }
  }
  .content {
    margin-bottom: 5em;
    .select {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 0.5em;
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    background: #EFEFF4;
    width: 90%;
    padding: 1em;
    border: 1px solid #EFEFF4;
    .part {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .info {
        font-size: 0.17rem;
        font-weight: 400;
        color: #3B86FF;
        display: flex;
        align-items: center;
      }
    }

  }
}
</style>
